import styled from 'styled-components';
import { RowStyled } from '../RowStyled';

export const RowStyledDS = styled(RowStyled)``;
